import { SB_LANGUAGES } from '~/modules/storyblok/constants';

export const removeLocale = (slug: string) => {
  const LANGS = Object.values(SB_LANGUAGES);
  const matchedLang = LANGS.find((lang) => slug.startsWith(`/${lang}/`));

  if (matchedLang) {
    return slug.slice(`/${matchedLang}/`.length);
  }

  return slug.startsWith('/') ? slug.slice(1) : slug;
};
